import { render, staticRenderFns } from "./returnPage.vue?vue&type=template&id=b95f90ba&scoped=true&"
import script from "./returnPage.vue?vue&type=script&lang=js&"
export * from "./returnPage.vue?vue&type=script&lang=js&"
import style0 from "./returnPage.vue?vue&type=style&index=0&id=b95f90ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95f90ba",
  null
  
)

export default component.exports